<template>
  <div class="form-group">
    <label for="card-url">Ajouter une carte avec son url</label>
    <div class="url-input">
      <input id="card-url" class="form-control" type="text" v-model="url" placeholder="coller ici l'url de la carte">
      <button class="btn btn-secondary" v-on:click="validateUrl">soumettre l'url</button>
    </div>
    <b-alert v-if="error" variant="danger" show>
      Impossible de trouver une carte correspondant à cette url
    </b-alert>
  </div>
</template>

<script>

  import axios from 'axios'

  export default {

    name: 'AddCardByUrl',

    data() {
      return {
        url: '',
        error: false,
        card: {}
      }
    },

    methods: {
      validateUrl: function (e) {
        e.preventDefault()
        if (this.url === '') {
          return false
        }
        let shortId = this.url.replace('https://trello.com/c/', '').split('/')[0]
        window.Trello.get('cards/' + shortId, this.onValidationSuccess, this.onValidationError)
      },

      onValidationSuccess: function (data) {
        this.error = false
        this.card = {
          id: data.id,
          name: data.name,
          desc: data.desc,
        }
        this.$emit('change-selected', this.card)
      },

      onValidationError: function (error) {
        this.error = true
      }
    }
  }

</script>

<style scoped>
  .url-input {
    display: flex;
    flex-wrap: wrap;
  }

  .url-input input {
    flex: 8;
  }

  .url-input button {
    flex: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/AssociateSub/AddCardByUrl.vue